export interface Device {
    id: string;
    status: Device.Status;
    statusUpdatedAt: Date;
    cid: number;
    organization: string;
    location: string;
    transfer: {
        up: number;
        down: number;
    };
    transferConfig: {
        badUp: number;
        badDown: number;
    };
    lcs: string;
    ems: string;
    nextEvent?: {
        id: string;
        startTime: Date;
        endTime: Date;
        name: string;
        operatorName?: string;
    };
    session: Device.Session;
    graphics: string;
}

export namespace Device {
    export enum Session {
        'active',
        'inactive',
        'offline'
    }

    export enum Status {
        'offline',
        'online'
    }
}
